// extracted by mini-css-extract-plugin
export var CallForAction = "index-module--CallForAction--7e76a";
export var GiftIcon = "index-module--GiftIcon--6295f";
export var LoginIcon = "index-module--LoginIcon--bc905";
export var LoginIconWrapper = "index-module--LoginIconWrapper--ded77";
export var SkipLink = "index-module--SkipLink--9da4d";
export var Subtitle = "index-module--Subtitle--11e49";
export var Title = "index-module--Title--c769e";